export default __webpack_public_path__ + "static/media/8.b95b3bae.jpg";